import React, { useState, useEffect } from "react";
import moment from "moment";

import { Row, Column } from "components/Layout";
import Checkbox from "components/Checkbox";
import ElementModal from "./ElementModal";
import style from './_modal.module.scss';


export default function PhenologyAgendaModal({ isOpen, onClose, onSubmit, agenda, setAgenda, allDevices }) {
	const [name, setName] = useState()
	const [year, setYear] = useState()
	const [devices, setDevices] = useState()
	const [cultivar, setCultivar] = useState()
	const [startDate, setStartDate] = useState()
	const [endDate, setEndDate] = useState()
	const [renew, setRenew] = useState()

	useEffect(() => {
		if (agenda) {
			setName(agenda.name)
			setYear(agenda.year)
			setDevices(agenda.devices)
			setStartDate(agenda.startDate)
			setEndDate(agenda.endDate)
			setCultivar(agenda.cultivar)
			setRenew(agenda.renew)
		} else {
			setName("nuovo calendario")
			setYear(new Date().getFullYear())
			setDevices([])
			setStartDate(moment().startOf('year').format('YYYY-MM-DD'))
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCultivar("")
			setRenew(true)
		}
	}, [agenda])

	function submit() {
		let newAgenda = {
			...agenda,
			name,
			year,
			devices,
			startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
			endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
			cultivar,
			renew,
		}
		setAgenda(newAgenda)
		onSubmit(newAgenda)
	}

	function isDeviceChecked(device) {
		return devices ? devices.includes(device) : false
	}

	function toggleDeviceChecked(device) {
		let newDevices = devices?.slice() || []
		if (newDevices.includes(device)) {
			newDevices = newDevices.filter(d => d !== device)
		} else {
			newDevices.push(device)
		}
		setDevices(newDevices)
	}

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} submit={submit}>
			<Column className={style.section}>
				<Row className={style.title}>
					Calendario fenologico
				</Row>
				<Row className={style.fields}>
					Nome
					<input
						type='text'
						value={name}
						onChange={e => setName(e.target.value)}
						required
					/>
				</Row>
				<Row className={style.fields}>
					Anno
					<input
						type='number'
						value={year}
						min={2020}
						max={2100}
						onChange={e => setYear(e.target.value)}
					/>
				</Row>
				<Column className={style.fields}>
					<Row>Dispositivi associati</Row>
					{
						allDevices.map(({ device, label }) =>
							<Row key={device}>
								<Checkbox
									checked={isDeviceChecked(device)}
									onCheck={e => toggleDeviceChecked(device)}
								/>
								{device + (label ? ` - ${label}` : "")}
							</Row>
						)
					}
				</Column>
				<Row className={style.fields}>
					Data inizio
					<input
						type='date'
						value={startDate}
						onChange={e => setStartDate(e.target.value)}
						required
					/>
				</Row>
				<Row className={style.fields}>
					Data fine
					<input
						type='date'
						value={endDate}
						onChange={e => setEndDate(e.target.value)}
						required
					/>
				</Row>
				<Row className={style.fields}>
					Cultivar
					<input
						type='text'
						value={cultivar}
						onChange={e => setCultivar(e.target.value)}
						required
					/>
				</Row>
				<Row className={style.fields}>
					Rinnovo automatico
					<Checkbox
						checked={renew}
						onCheck={e => setRenew(e.target.checked)}
					/>
				</Row>
			</Column>
		</ElementModal>
	)
}
